
import { defineComponent } from "vue"

export default defineComponent({
  layoutSettings: {
    fullWidth: true,
  },
})
